"use client"

import React, { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import "react-calendar/dist/Calendar.css"
import "react-multi-carousel/lib/styles.css"
import { appInsights } from "./AppInsights"
import AADHeader from "./components/AADHeader.js"
import LoginHeader from "./components/LoginHeader.js"
import SideNavigation from "./components/SideNavigation.js"
import Highcharts from "highcharts"
import HighchartsReact from "highcharts-react-official"
import HighchartsExporting from "highcharts/modules/exporting"
import HighchartsFullscreen from "highcharts/modules/full-screen"
import HighchartsMap from "highcharts/modules/map"
import HighchartsOfflineExporting from "highcharts/modules/offline-exporting"
import SolidGauge from "highcharts/modules/solid-gauge"
import highchartsMore from "highcharts/highcharts-more"
import proj4 from "proj4"
import { MultiSelect } from "primereact/multiselect"
import { ResponsiveContainer } from "recharts"
import { Backdrop, Breadcrumbs, Button, CircularProgress, Link, Typography } from "@mui/material"
import NavigateNextIcon from "@mui/icons-material/NavigateNext"
import { MdRefresh } from "react-icons/md"

// No Data Component
const NoDataComponent = ({ title, onConfigureClick }) => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      height: "280px",
      backgroundColor: "#f8f9fa",
      borderRadius: "8px",
      border: "1px dashed #dee2e6",
      textAlign: "center",
      padding: "20px",
    }}
  >
    <div style={{ marginBottom: "20px" }}>
      <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M9 17H7V10H9M13 17H11V7H13M17 17H15V13H17M19.5 19.1H4.5V5H19.5M19.5 3H4.5C3.4 3 2.5 3.9 2.5 5V19.1C2.5 20.2 3.4 21.1 4.5 21.1H19.5C20.6 21.1 21.5 20.2 21.5 19.1V5C21.5 3.9 20.6 3 19.5 3Z"
          fill="#6c757d"
        />
      </svg>
    </div>
    <h6 style={{ color: "#6c757d", marginBottom: "10px", fontFamily: "Poppins" }}>No Data Available</h6>
    <p style={{ color: "#6c757d", marginBottom: "20px", fontSize: "14px" }}>Please configure the data for visual</p>
    <Button
      variant="contained"
      onClick={onConfigureClick}
      style={{
        backgroundColor: "#407775",
        color: "white",
        textTransform: "none",
        fontFamily: "Poppins",
        borderRadius: "6px",
        padding: "8px 20px",
      }}
    >
      Configure Data
    </Button>
  </div>
)

// Initialize the exporting module
HighchartsExporting(Highcharts)
HighchartsOfflineExporting(Highcharts)
HighchartsFullscreen(Highcharts)
HighchartsMap(Highcharts)
highchartsMore(Highcharts)
SolidGauge(Highcharts)

/// Global Highcharts options for consistent styling
Highcharts.setOptions({
  colors: [
    "#407775",
    "#fab430",
    "#c8e1e0",
    "#b8d9d8",
    "#b8d9d8",
    "#b8d9d8",
    "#b8d9d8",
    "#fcd283",
    "#fde4b4",
    "#fbc051",
    "#e09405",
    "#fef6e6",
  ],
  chart: {
    style: {
      fontFamily: "Poppins, sans-serif",
    },
    backgroundColor: "#ffffff",
    height: 300, // Set a compact height for all charts
  },
  title: {
    style: {
      fontSize: "16px",
      fontWeight: "400",
      color: "#494949",
    },
    align: "left",
  },
  legend: {
    enabled: true,
    itemStyle: {
      color: "#494949",
      fontWeight: "400",
      fontSize: "12px",
    },
    itemMarginTop: 6,
    itemMarginBottom: 6,
    symbolRadius: 6,
  },
  tooltip: {
    style: {
      fontSize: "12px",
    },
  },
  xAxis: {
    labels: {
      style: {
        fontSize: "12px",
        color: "#707070",
      },
    },
  },
  yAxis: {
    labels: {
      style: {
        fontSize: "12px",
        color: "#707070",
      },
    },
    title: {
      style: {
        fontSize: "14px",
        color: "#C2BEBE",
      },
    },
  },
  credits: {
    enabled: false, // Disable Highcharts credit label
  },
  exporting: {
    enabled: false, // Hide export/download button
  },
})

// CSS for compact chart containers
const chartContainerStyle = `
  .charts {
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    padding: 15px;
    margin-bottom: 20px;
    height: 350px; /* Fixed height for compact charts */
    overflow: hidden;
  }
  @media (max-width: 768px) {
    .charts {
      height: 300px; /* Smaller height for mobile */
    }
  }
`

// Inject CSS into the document
const styleSheet = document.createElement("style")
styleSheet.type = "text/css"
styleSheet.innerText = chartContainerStyle
document.head.appendChild(styleSheet)

export default function Home() {
  const username = localStorage.getItem("userName")
  const companyid = localStorage.getItem("companyid")
  const navigate = useNavigate()
  const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 768)
  const [isLoading, setIsLoading] = useState(false)
  const [loading, setLoading] = React.useState(false)
  const [emissionbased, setEmissionBased] = React.useState(false)
  const [news, setNews] = useState(false)
  const [responseConfig, setResponseConfig] = useState({})
  const [legal, setLegal] = useState([])
  const [business, setBusiness] = useState([])
  const [site, setSite] = useState([])
  const [year, setYear] = useState([])
  const [country, setCountry] = useState([])
  const [employee, setEmployee] = useState("")
  const [scope, setScope] = useState("")
  const [yearr, setYearR] = useState("")
  const [countries, setCountries] = useState()
  const [businessunit, setBusinessUnit] = useState()
  const [activesite, setActiveSite] = useState()
  const [activeetities, setActiveEntities] = useState()
  const [activeyears, setActiveYears] = useState()
  const [checked, setChecked] = useState(true)
  const [viewMode, setViewMode] = useState("locationBased")
  const [optionsChart4, setOptionsChart4] = useState({})
  const [optionsChart6, setOptionsChart6] = useState({})

  // Add state for last refresh time
  const [lastRefreshTime, setLastRefreshTime] = useState(null)

  const currentYear = new Date().getFullYear()
  const previousYear = currentYear - 1

  // Function to handle configuration redirect
  const handleConfigureClick = () => {
    navigate("/configuration") // Update this path to your actual configuration route
  }

  // Function to check if data exists and has values
  const hasValidData = (data) => {
    if (!data || typeof data !== "object") return false
    if (Array.isArray(data)) return data.length > 0
    return Object.keys(data).length > 0 && Object.values(data).some((value) => value > 0)
  }

  if (typeof window !== "undefined") {
    window.proj4 = window.proj4 || proj4
  }

  // Function to format date and time
  const formatDateTime = (date) => {
    if (!date) return ""
    const options = {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    }
    return date.toLocaleString("en-US", options)
  }

  // Function to handle toggle change
  const handleToggleChange = (value) => {
    console.log(value)
    if (value === true) {
      setViewMode("locationBased")
      setChecked(value)
    } else {
      setViewMode("marketBased")
      setChecked(value)
    }
  }

  function truncateText(text, maxLength) {
    if (text.length > maxLength) {
      return text.substring(0, maxLength) + "..."
    }
    return text
  }

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev)
  }

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setIsSidebarOpen(false) // Close sidebar on mobile
      } else {
        setIsSidebarOpen(true) // Open sidebar on larger screens
      }
    }

    window.addEventListener("resize", handleResize)

    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  var myHeaders = new Headers()
  myHeaders.append("username", username)
  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  }

  const emissionsData = {
    EmployeeCommute: {
      2023: { value: 6163 },
      2022: { value: 6348 },
      change: -3,
      icon: "../assets/img/icon/EmployeeCommute.svg",
    },
    PersonalVehicle: {
      2023: { value: 2511 },
      2022: { value: 2789 },
      change: -10,
      icon: "../assets/img/icon/PersonalVehicle.svg",
    },
    SharedTransport: {
      2023: { value: 3652 },
      2022: { value: 3200 },
      change: 2,
      icon: "../assets/img/icon/SharedTransport.svg",
    },
  }
  const emissionscommuteData = [
    { id: 1, name: "Car", y: 39, color: "#707070" },
    { id: 2, name: "Motorcycle", y: 2, color: "#EBEBEB" },
    { id: 3, name: "Cab", y: 30, color: "#B4A34A" },
    { id: 4, name: "Bus", y: 10, color: "#B4C9C8" },
    { id: 5, name: "Metro", y: 6, color: "#D3EAE9" },
    { id: 6, name: "Others", y: 13, color: "#FAB430" },
  ]

  const commuteModeData = [
    { id: 1, name: "Car", y: 19, color: "#B4C9C8" },
    { id: 2, name: "Motorcycle", y: 3, color: "#D3EAE9" },
    { id: 3, name: "Bus", y: 37, color: "#B4A34A" },
    { id: 4, name: "Metro", y: 29, color: "#7A756B" },
    { id: 5, name: "Bicycle", y: 11, color: "#FAB430" },
  ]

  const averageTravelCommuteMode = {
    title: "Average one-way travel (km) by commute mode",
    subtitle: "Average distance from home to office (km)",
    data: [
      { name: "Car", y: 27 },
      { name: "Motorcycle", y: 12 },
      { name: "Cab", y: 18 },
      { name: "Bus", y: 32 },
      { name: "Metro", y: 37 },
      { name: "Bicycle", y: 7 },
    ],
    color: "#B4A34A",
  }

  const averageTravelSiteLocation = {
    title: "Average one-way travel (km) by Site Location",
    subtitle: "Average distance from home to office (km)",
    data: [
      { name: "Site 1", y: 27 },
      { name: "Site 2", y: 12 },
      { name: "Site 3", y: 18 },
      { name: "Site 4", y: 32 },
      { name: "Site 5", y: 32 },
      { name: "Site 6", y: 32 },
      { name: "Site 7", y: 32 },
      { name: "Site 8", y: 32 },
      { name: "Site 9", y: 32 },
      { name: "Site 10", y: 32 },
    ],
    color: "#B4C9C8",
  }

  const annualEmissionSite = {
    title: "Annual per-employee emission by site",
    subtitle: "Per employee emissions (tCO2e/employee)",
    data: [
      { name: "Site 1", y: 11.01 },
      { name: "Site 2", y: 6.02 },
      { name: "Site 3", y: 4.0 },
      { name: "Site 4", y: 6.22 },
      { name: "Site 5", y: 3.23 },
      { name: "Site 6", y: 2.12 },
      { name: "Site 7", y: 2.12 },
      { name: "Site 8", y: 2.12 },
      { name: "Site 9", y: 2.12 },
      { name: "Site 10", y: 2.12 },
    ],
    color: "#FAB430",
  }

  // Data validation for each chart
  const hasEmissionsCommuteData = hasValidData(emissionscommuteData) && emissionscommuteData.some((item) => item.y > 0)
  const hasCommuteModeData = hasValidData(commuteModeData) && commuteModeData.some((item) => item.y > 0)
  const hasAverageTravelCommuteData =
    hasValidData(averageTravelCommuteMode.data) && averageTravelCommuteMode.data.some((item) => item.y > 0)
  const hasAverageTravelSiteData =
    hasValidData(averageTravelSiteLocation.data) && averageTravelSiteLocation.data.some((item) => item.y > 0)
  const hasAnnualEmissionSiteData =
    hasValidData(annualEmissionSite.data) && annualEmissionSite.data.some((item) => item.y > 0)

  async function fetchFilters() {
    try {
      const country = JSON.parse(localStorage.getItem("employeeCommuteCountry")) || []
      const year = JSON.parse(localStorage.getItem("employeeCommuteYear")) || []
      const legal = JSON.parse(localStorage.getItem("employeeCommuteLegal")) || []
      const business = JSON.parse(localStorage.getItem("employeeCommuteBusiness")) || []
      const site = JSON.parse(localStorage.getItem("employeeCommuteSite")) || []

      const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}api-business-travel-dashboard-filters`, {
        method: "POST",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          username: username,
        },
        body: JSON.stringify({
          companyId: companyid,
          year: year,
          legalEntity: legal,
          businessUnit: business,
          country: country,
          site: site,
        }),
      })

      if (response.status === 200) {
        const responseJson = await response.json()

        if (responseJson.success === false || responseJson.status === 400) {
          setActiveEntities("")
          setActiveYears("")
          setBusinessUnit("")
          setCountries("")
          setActiveSite("")
        } else {
          let legalOptions
          let businessOptions
          let countryOptions
          let siteOptions
          let yearOptions
          // Check if any filters are selected
          const isAnyFilterSelected =
            year.length > 0 || legal.length > 0 || business.length > 0 || country.length > 0 || site.length > 0

          // Generate dropdown options based on whether any filters are selected
          if (
            year.length > 0 &&
            legal.length === 0 &&
            business.length === 0 &&
            country.length === 0 &&
            site.length === 0
          ) {
            yearOptions = Object.entries(responseJson.year).map(([key]) => ({
              label: key,
              value: key,
            }))
          } else {
            yearOptions = Object.entries(responseJson.year)
              .map(([key]) => ({
                label: key,
                value: key,
              }))
          }

          if (
            year.length === 0 &&
            legal.length > 0 &&
            business.length === 0 &&
            country.length === 0 &&
            site.length === 0
          ) {
            legalOptions = Object.entries(responseJson.legalEntity).map(([key]) => ({
              label: key,
              value: key,
            }))
          } else {
            legalOptions = Object.entries(responseJson.legalEntity)
              .map(([key]) => ({
                label: key,
                value: key,
              }))
          }

          if (
            year.length === 0 &&
            legal.length === 0 &&
            business.length > 0 &&
            country.length === 0 &&
            site.length === 0
          ) {
            businessOptions = Object.entries(responseJson.businessUnit).map(([key]) => ({
              label: key,
              value: key,
            }))
          } else {
            businessOptions = Object.entries(responseJson.businessUnit)
              .map(([key]) => ({
                label: key,
                value: key,
              }))
          }

          if (
            year.length === 0 &&
            legal.length === 0 &&
            business.length === 0 &&
            country.length > 0 &&
            site.length === 0
          ) {
            countryOptions = Object.entries(responseJson.country).map(([key]) => ({
              label: key,
              value: key,
            }))
          } else {
            countryOptions = Object.entries(responseJson.country)
              .map(([key]) => ({
                label: key,
                value: key,
              }))
          }

          if (
            year.length === 0 &&
            legal.length === 0 &&
            business.length === 0 &&
            country.length === 0 &&
            site.length > 0
          ) {
            siteOptions = Object.entries(responseJson.site).map(([key]) => ({
              label: key,
              value: key,
            }))
          } else {
            siteOptions = Object.entries(responseJson.site)
              .map(([key]) => ({
                label: key,
                value: key,
              }))
          }

          // Set the dropdown options
          setActiveYears(yearOptions)
          setActiveEntities(legalOptions)
          setBusinessUnit(businessOptions)
          setCountries(countryOptions)
          setActiveSite(siteOptions)

          // Update local storage with selected values
          localStorage.setItem("employeeCommuteLegal", JSON.stringify(legal))
          setLegal(legal)

          localStorage.setItem("employeeCommuteBusiness", JSON.stringify(business))
          setBusiness(business)

          localStorage.setItem("employeeCommuteCountry", JSON.stringify(country))
          setCountry(country)

          localStorage.setItem("employeeCommuteSite", JSON.stringify(site))
          setSite(site)

          localStorage.setItem("employeeCommuteYear", JSON.stringify(year))
          setYear(year)
        }
      } else {
        setActiveEntities("")
        setActiveYears("")
        setBusinessUnit("")
        setCountries("")
        setActiveSite("")
      }
    } catch (error) {
      console.error(error)
    }
  }

  async function fetchScope2() {
    try {
      setLoading(true)
      const companyid = localStorage.getItem("companyid")
      const country = JSON.parse(localStorage.getItem("employeeCommuteCountry")) || []
      const year = JSON.parse(localStorage.getItem("employeeCommuteYear")) || []
      const legal = JSON.parse(localStorage.getItem("employeeCommuteLegal")) || []
      const business = JSON.parse(localStorage.getItem("employeeCommuteBusiness")) || []
      const site = JSON.parse(localStorage.getItem("employeeCommuteSite")) || []
      var myHeaders = new Headers()
      myHeaders.append("username", username)
      var requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      }
      const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}api-business-travel-dashboard`, {
        method: "POST",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          username: username,
        },
        body: JSON.stringify({
          companyId: companyid,
          year: year,
          legalEntity: legal,
          businessUnit: business,
          country: country,
          site: site,
        }),
      })
      if (response.status === 200) {
        const responseJson = await response.json()
        if (responseJson.success === false || responseJson.status === 400) {
          setLoading(false)
        } else {
          setScope(responseJson)
          // Update last refresh time when data is successfully fetched
          setLastRefreshTime(new Date())
          setLoading(false)
        }
      } else {
        setLoading(false)
      }
    } catch (error) {
      console.error(error)
      setLoading(false)
    }
  }

  useEffect(() => {
    appInsights.trackPageView()
    fetchFilters()
    fetchScope2()
  }, [])

  const handleLegalChange = (selectedLegal) => {
    setLegal(selectedLegal)
    localStorage.setItem("employeeCommuteLegal", JSON.stringify(selectedLegal))
    fetchScope2()
    fetchFilters()
  }

  const handleBusinessChange = (selectedBusiness) => {
    setBusiness(selectedBusiness)
    localStorage.setItem("employeeCommuteBusiness", JSON.stringify(selectedBusiness))
    fetchScope2()
    fetchFilters()
  }

  const handleCountryChange = (selectedCountry) => {
    setCountry(selectedCountry)
    localStorage.setItem("employeeCommuteCountry", JSON.stringify(selectedCountry))
    fetchScope2()
    fetchFilters()
  }

  const handleSiteChange = (selectedSite) => {
    setSite(selectedSite)
    localStorage.setItem("employeeCommuteSite", JSON.stringify(selectedSite))
    fetchScope2()
    fetchFilters()
  }

  const handleYearChange = (selectedYear) => {
    setYear(selectedYear)
    localStorage.setItem("employeeCommuteYear", JSON.stringify(selectedYear))
    fetchScope2()
    fetchFilters()
  }

  // Consuption by supplier start
  const consumptionBySupplier = scope && scope.consumptionBySupplier

  const seriesData = consumptionBySupplier
    ? Object.entries(consumptionBySupplier).map(([supplierName, electricityConsumption]) => ({
        name: supplierName,
        y: Number.parseFloat(electricityConsumption),
      }))
    : []
  const seriesData_location = consumptionBySupplier
    ? Object.entries(consumptionBySupplier).map(([supplierName, electricityConsumption]) => ({
        name: supplierName,
        y: Number.parseFloat(electricityConsumption),
      }))
    : []

  const activeyear = activeyears && activeyears.map((status) => status)
  console.log(activeyear)
  const activelegal = activeetities && activeetities.map((status) => status)
  const activebusiness = businessunit && businessunit.map((status) => status)
  const activesites = activesite && activesite.map((status) => status)
  const activecountry = countries && countries.map((status) => status)
  console.log(activecountry)
  //const activeyear = yearss.map((status) => status.name);

  const renderHeader = () => {
    const loginType = localStorage.getItem("loginType")
    if (loginType === "AAD") {
      return <AADHeader toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} heading="" />
    }
    return <LoginHeader toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} heading="" />
  }

  const handleResetFilters = async () => {
    try {
      setLoading(true)
      // Clear all selected filters in state
      setLegal([])
      setBusiness([])
      setCountry([])
      setSite([])
      setYear([])

      // Clear all selected filters in local storage
      localStorage.removeItem("employeeCommuteLegal")
      localStorage.removeItem("employeeCommuteBusiness")
      localStorage.removeItem("employeeCommuteCountry")
      localStorage.removeItem("employeeCommuteSite")
      localStorage.removeItem("employeeCommuteYear")

      // Fetch filters again to reset dropdowns to show all values
      await fetchFilters()

      // Fetch scope 2 data again with no filters applied
      await fetchScope2()
    } catch (error) {
      console.error("Error resetting filters:", error)
    }
  }

  // Handle manual refresh
  const handleRefresh = () => {
    fetchScope2()
    fetchFilters()
  }

  const [selectedOption, setSelectedOption] = useState("Upstream")

  const handleSelect = (option) => {
    setSelectedOption(option)
  }

  // Updated Chart Configurations with 16px titles, 12px legends, and improved responsiveness

  //chart1 - Emissions share by commute mode
  const emissionsChartConfig = {
    chart: {
      type: "pie",
      style: {
        fontFamily: "poppins",
      },
      spacing: [20, 20, 20, 20],
      height: 350,
    },
    credits: {
      enabled: false,
    },
    title: {
      text: "Emissions share by commute mode",
      align: "left",
      style: {
        fontSize: "16px",
        fontWeight: "400",
        color: "#2b2b2b",
      },
    },
    tooltip: {
      pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        center: ["65%", "50%"], // Move pie chart to the right to make room for left legend
        size: "60%", // Reduce pie chart size
        dataLabels: {
          enabled: true,
          connectorColor: "#707070",
          format: "{point.percentage:.0f}%",
          style: {
            color: "#333",
            fontWeight: "400",
            fontSize: "11px",
          },
          distance: 15,
        },
        showInLegend: true,
      },
    },
    legend: {
      enabled: true,
      layout: "vertical",
      align: "left",
      verticalAlign: "middle",
      borderWidth: 0,
      itemStyle: {
        color: "#494949",
        fontWeight: "400",
        fontSize: "12px",
      },
      itemMarginTop: 4,
      itemMarginBottom: 4,
      symbolRadius: 8,
      x: 20,
      y: 0,
    },
    series: [
      {
        name: "Commute Mode",
        data: emissionscommuteData.map((item) => ({
          id: item.id,
          name: item.name,
          y: item.y,
          color: item.color,
        })),
      },
    ],
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 480,
          },
          chartOptions: {
            chart: {
              height: 280,
            },
            plotOptions: {
              pie: {
                center: ["50%", "45%"],
                size: "65%",
                dataLabels: {
                  style: {
                    fontSize: "10px",
                  },
                },
              },
            },
            legend: {
              layout: "horizontal",
              align: "center",
              verticalAlign: "bottom",
              itemStyle: {
                fontSize: "11px",
              },
              x: 0,
              y: 20,
            },
          },
        },
      ],
    },
  }

  //chart2 - Primary commute mode of employees
  const commuteModeChartConfig = {
    chart: {
      type: "pie",
      style: {
        fontFamily: "poppins",
      },
      spacing: [20, 20, 20, 20],
      height: 350,
    },
    credits: {
      enabled: false,
    },
    title: {
      text: "Primary commute mode of employees",
      align: "left",
      style: {
        fontSize: "16px",
        fontWeight: "400",
        color: "#2b2b2b",
      },
    },
    tooltip: {
      pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        center: ["65%", "50%"], // Move pie chart to the right to make room for left legend
        size: "60%", // Reduce pie chart size
        dataLabels: {
          enabled: true,
          connectorColor: "#707070",
          format: "{point.percentage:.0f}%",
          style: {
            color: "#333",
            fontWeight: "400",
            fontSize: "11px",
          },
          distance: 15,
        },
        showInLegend: true,
      },
    },
    legend: {
      enabled: true,
      layout: "vertical",
      align: "left",
      verticalAlign: "middle",
      borderWidth: 0,
      itemStyle: {
        color: "#494949",
        fontWeight: "400",
        fontSize: "12px",
      },
      itemMarginTop: 4,
      itemMarginBottom: 4,
      symbolRadius: 8,
      x: 20,
      y: 0,
    },
    series: [
      {
        name: "Commute Mode",
        data: commuteModeData.map((item) => ({
          id: item.id,
          name: item.name,
          y: item.y,
          color: item.color,
        })),
      },
    ],
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 480,
          },
          chartOptions: {
            chart: {
              height: 280,
            },
            plotOptions: {
              pie: {
                center: ["50%", "45%"],
                size: "65%",
                dataLabels: {
                  style: {
                    fontSize: "10px",
                  },
                },
              },
            },
            legend: {
              layout: "horizontal",
              align: "center",
              verticalAlign: "bottom",
              itemStyle: {
                fontSize: "11px",
              },
              x: 0,
              y: 20,
            },
          },
        },
      ],
    },
  }

  //chart3 - Average one-way travel by commute mode
  const averageTravelCommuteModeChartConfig = {
    chart: {
      type: "column",
      style: {
        fontFamily: "poppins",
      },
      spacing: [20, 40, 30, 40],
    },
    credits: {
      enabled: false, // Remove Highcharts branding
    },
    title: {
      text: averageTravelCommuteMode.title,
      align: "left",
      style: {
        fontWeight: "400",
        fontSize: "16px", // Updated to 16px
        color: "#2b2b2b",
      },
    },
    plotOptions: {
      column: {
        pointWidth: 35,
        borderRadius: 0,
        dataLabels: {
          enabled: true,
          style: {
            fontWeight: "400",
            fontSize: "11px",
          },
          format: "{point.y}",
        },
      },
    },
    xAxis: {
      categories: averageTravelCommuteMode.data.map((item) => item.name),
      gridLineWidth: 0,
      labels: {
        style: {
          fontSize: "12px", // Updated to 12px for legends/labels
          color: "#707070",
        },
        y: 15,
      },
    },
    yAxis: {
      tickInterval: 5,
      title: {
        text: "Average distance from home to office (km)",
        style: {
          fontSize: "12px",
          color: "#707070",
        },
      },
      labels: {
        formatter: function () {
          return this.value
        },
        style: {
          fontSize: "12px", // Updated to 12px for legends/labels
          color: "#707070",
        },
      },
      gridLineWidth: 1,
      gridLineColor: "#e6e6e6",
    },
    legend: {
      enabled: false,
    },
    series: [
      {
        name: "Average Distance",
        data: averageTravelCommuteMode.data.map((item) => ({
          y: item.y,
          color: averageTravelCommuteMode.color,
        })),
      },
    ],
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 768,
          },
          chartOptions: {
            chart: {
              spacing: [15, 20, 20, 20],
            },
            title: {
              style: {
                fontSize: "16px",
              },
            },
            plotOptions: {
              column: {
                pointWidth: 25,
                dataLabels: {
                  style: {
                    fontSize: "10px",
                  },
                },
              },
            },
            xAxis: {
              labels: {
                style: {
                  fontSize: "11px",
                },
              },
            },
            yAxis: {
              labels: {
                style: {
                  fontSize: "11px",
                },
              },
              title: {
                style: {
                  fontSize: "11px",
                },
              },
            },
          },
        },
        {
          condition: {
            maxWidth: 480,
          },
          chartOptions: {
            chart: {
              spacing: [10, 15, 15, 15],
            },
            title: {
              style: {
                fontSize: "14px",
              },
            },
            plotOptions: {
              column: {
                pointWidth: 20,
                dataLabels: {
                  style: {
                    fontSize: "9px",
                  },
                },
              },
            },
            xAxis: {
              labels: {
                style: {
                  fontSize: "10px",
                },
              },
            },
            yAxis: {
              labels: {
                style: {
                  fontSize: "10px",
                },
              },
              title: {
                style: {
                  fontSize: "10px",
                },
              },
            },
          },
        },
      ],
    },
  }

  //chart4 - Average one-way travel by site location
  const averageTravelSiteLocationChartConfig = {
    chart: {
      type: "column",
      style: {
        fontFamily: "poppins",
      },
      spacing: [20, 40, 30, 40],
    },
    credits: {
      enabled: false, // Remove Highcharts branding
    },
    title: {
      text: averageTravelSiteLocation.title,
      align: "left",
      style: {
        fontWeight: "400",
        fontSize: "16px", // Updated to 16px
        color: "#2b2b2b",
      },
    },
    plotOptions: {
      column: {
        pointWidth: 25,
        borderRadius: 0,
        dataLabels: {
          enabled: true,
          style: {
            fontWeight: "400",
            fontSize: "11px",
          },
          format: "{point.y}",
        },
      },
    },
    xAxis: {
      categories: averageTravelSiteLocation.data.map((item) => item.name),
      gridLineWidth: 0,
      labels: {
        style: {
          fontSize: "12px", // Updated to 12px for legends/labels
          color: "#707070",
        },
        y: 15,
      },
    },
    yAxis: {
      tickInterval: 5,
      title: {
        text: "Average distance from home to office (km)",
        style: {
          fontSize: "12px",
          color: "#707070",
        },
      },
      labels: {
        formatter: function () {
          return this.value
        },
        style: {
          fontSize: "12px", // Updated to 12px for legends/labels
          color: "#707070",
        },
      },
      gridLineWidth: 1,
      gridLineColor: "#e6e6e6",
    },
    legend: {
      enabled: false,
    },
    series: [
      {
        name: "Average Distance",
        data: averageTravelSiteLocation.data.map((item) => ({
          y: item.y,
          color: averageTravelSiteLocation.color,
        })),
      },
    ],
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 768,
          },
          chartOptions: {
            chart: {
              spacing: [15, 20, 20, 20],
            },
            title: {
              style: {
                fontSize: "16px",
              },
            },
            plotOptions: {
              column: {
                pointWidth: 15,
                dataLabels: {
                  style: {
                    fontSize: "10px",
                  },
                },
              },
            },
            xAxis: {
              labels: {
                style: {
                  fontSize: "11px",
                },
              },
            },
            yAxis: {
              labels: {
                style: {
                  fontSize: "11px",
                },
              },
              title: {
                style: {
                  fontSize: "11px",
                },
              },
            },
          },
        },
        {
          condition: {
            maxWidth: 480,
          },
          chartOptions: {
            chart: {
              spacing: [10, 15, 15, 15],
            },
            title: {
              style: {
                fontSize: "14px",
              },
            },
            plotOptions: {
              column: {
                pointWidth: 12,
                dataLabels: {
                  style: {
                    fontSize: "9px",
                  },
                },
              },
            },
            xAxis: {
              labels: {
                style: {
                  fontSize: "10px",
                },
              },
            },
            yAxis: {
              labels: {
                style: {
                  fontSize: "10px",
                },
              },
              title: {
                style: {
                  fontSize: "10px",
                },
              },
            },
          },
        },
      ],
    },
  }

  //chart5 - Annual per-employee emission by site
  const annualEmissionSiteChartConfig = {
    chart: {
      type: "column",
      style: {
        fontFamily: "poppins",
      },
      spacing: [20, 40, 30, 40],
    },
    credits: {
      enabled: false, // Remove Highcharts branding
    },
    title: {
      text: annualEmissionSite.title,
      align: "left",
      style: {
        fontWeight: "400",
        fontSize: "16px", // Updated to 16px
        color: "#2b2b2b",
      },
    },
    plotOptions: {
      column: {
        pointWidth: 25,
        borderRadius: 0,
        dataLabels: {
          enabled: true,
          style: {
            fontWeight: "400",
            fontSize: "11px",
          },
          format: "{point.y}",
        },
      },
    },
    xAxis: {
      categories: annualEmissionSite.data.map((item) => item.name),
      gridLineWidth: 0,
      labels: {
        style: {
          fontSize: "12px", // Updated to 12px for legends/labels
          color: "#707070",
        },
        y: 15,
      },
    },
    yAxis: {
      tickInterval: 2,
      title: {
        text: "Per employee emissions (tCO2e/employee)",
        style: {
          fontSize: "12px",
          color: "#707070",
        },
      },
      labels: {
        formatter: function () {
          return this.value
        },
        style: {
          fontSize: "12px", // Updated to 12px for legends/labels
          color: "#707070",
        },
      },
      gridLineWidth: 1,
      gridLineColor: "#e6e6e6",
    },
    legend: {
      enabled: false,
    },
    series: [
      {
        name: "Emissions",
        data: annualEmissionSite.data.map((item) => ({
          y: item.y,
          color: annualEmissionSite.color,
        })),
      },
    ],
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 768,
          },
          chartOptions: {
            chart: {
              spacing: [15, 20, 20, 20],
            },
            title: {
              style: {
                fontSize: "16px",
              },
            },
            plotOptions: {
              column: {
                pointWidth: 15,
                dataLabels: {
                  style: {
                    fontSize: "10px",
                  },
                },
              },
            },
            xAxis: {
              labels: {
                style: {
                  fontSize: "11px",
                },
              },
            },
            yAxis: {
              labels: {
                style: {
                  fontSize: "11px",
                },
              },
              title: {
                style: {
                  fontSize: "11px",
                },
              },
            },
          },
        },
        {
          condition: {
            maxWidth: 480,
          },
          chartOptions: {
            chart: {
              spacing: [10, 15, 15, 15],
            },
            title: {
              style: {
                fontSize: "14px",
              },
            },
            plotOptions: {
              column: {
                pointWidth: 12,
                dataLabels: {
                  style: {
                    fontSize: "9px",
                  },
                },
              },
            },
            xAxis: {
              labels: {
                style: {
                  fontSize: "10px",
                },
              },
            },
            yAxis: {
              labels: {
                style: {
                  fontSize: "10px",
                },
              },
              title: {
                style: {
                  fontSize: "10px",
                },
              },
            },
          },
        },
      ],
    },
  }

  return (
    <div id="wrapper">
      <div>
        {loading && (
          <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={true}>
            <CircularProgress color="inherit" />
          </Backdrop>
        )}
      </div>
      {renderHeader()}
      <SideNavigation isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      <div id="page-content-wrapper" className={isSidebarOpen ? "page-content-wrapper-pd-0" : "page-wrapper"}>
        <div
          className="container"
          style={{ marginLeft: "auto", marginRight: "auto", paddingLeft: "30px", paddingRight: "20px" }}
        >
          <div className="row">
            <div className="col-12 col-md-8">
              <div className="steps__containt-hader">
                <div className="d-flex align-items-center gap-3 flex-wrap">
                  <h3 className="title mb-0">Employee commute</h3>
                  {lastRefreshTime && (
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#707070",
                        fontWeight: "400",
                      }}
                    >
                      Last Refresh: {formatDateTime(lastRefreshTime)}
                    </div>
                  )}
                </div>
                <div role="presentation" className="mt-2">
                  <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
                    <Link underline="hover" color="inherit" href="/esg-dashboard" className="link">
                      Dashboard
                    </Link>
                    <Typography color="text.primary">Employee commute</Typography>
                  </Breadcrumbs>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 d-flex align-items-center justify-content-md-end">
              <div className="row justify-content-md-end my-2">
                <div className="col-auto">
                  <Button className="refresh-cta" variant="text" startIcon={<MdRefresh />} onClick={handleRefresh}>
                    Refresh
                  </Button>
                </div>
              </div>
            </div>
          </div>

          <div className="row g-3">
            {[
              {
                label: "Legal Entity",
                value: legal,
                setValue: setLegal,
                handleChange: handleLegalChange,
                options: activelegal,
              },
              {
                label: "Business Unit",
                value: business,
                setValue: setBusiness,
                handleChange: handleBusinessChange,
                options: activebusiness,
              },
              { label: "Site", value: site, setValue: setSite, handleChange: handleSiteChange, options: activesites },
              {
                label: "Country",
                value: country,
                setValue: setCountry,
                handleChange: handleCountryChange,
                options: activecountry,
              },
              { label: "Year", value: year, setValue: setYear, handleChange: handleYearChange, options: activeyear },
            ].map(({ label, value, setValue, handleChange, options }, index) => (
              <div key={index} className="col-12 col-sm-6 col-md-4 col-lg-2">
                <label className="form-label">{label}</label>
                <MultiSelect
                  value={value}
                  onChange={(e) => {
                    setValue(e.target.value)
                    handleChange(e.target.value)
                  }}
                  options={options}
                  placeholder="All"
                  maxSelectedLabels={1}
                  className="w-100"
                  showClear
                  showSelectAll
                  selectAllLabel="Select All"
                />
              </div>
            ))}

            <div className="col-12 col-sm-6 col-md-4 col-lg-2 d-flex align-items-end">
              <Button
                onClick={handleResetFilters}
                variant="outlined"
                startIcon={<MdRefresh />}
                sx={{
                  backgroundColor: "#f5f5f5",
                  color: "#666",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                  padding: "8px 16px",
                  fontSize: "14px",
                  fontWeight: "400",
                  textTransform: "none",
                  minHeight: "40px",
                  width: "100%",
                  "&:hover": {
                    backgroundColor: "#e8e8e8",
                    border: "1px solid #ccc",
                  },
                  "&:focus": {
                    outline: "none",
                    boxShadow: "0 0 0 2px rgba(0,123,255,.25)",
                  },
                }}
              >
                Reset
              </Button>
            </div>
          </div>

          {scope && (
            <div>
              <div className="row mt-4">
                {Object.keys(emissionsData).map((key) => (
                  <div key={key} className="col-12 col-sm-12 col-md-6 col-lg-4 d-flex mb-4">
                    <div
                      className="bg-white p-3 shadow w-100 d-flex flex-column"
                      style={{
                        maxHeight: "180px",
                        borderRadius: "8px",
                        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                        paddingLeft: "40px", // Increased horizontal padding
                        paddingRight: "40px", // Increased horizontal padding
                      }}
                    >
                      <div className="d-flex align-items-center mb-3">
                        <img
                          src={emissionsData[key].icon || "/placeholder.svg"}
                          alt={`${key} icon`}
                          style={{
                            width: "40px",
                            height: "34px",
                            marginRight: "12px",
                            flexShrink: 0,
                          }}
                        />
                        <div
                          style={{
                            fontSize: "14px",
                            color: "#707070",
                            fontWeight: "600",
                            textAlign: "left",
                            lineHeight: 1.4,
                            minWidth: 0,
                          }}
                          title={`${key.replace(/([A-Z])/g, " $1").trim()} emissions (tCO₂e)`}
                        >
                          {key.replace(/([A-Z])/g, " $1").trim()} emissions (tCO₂e)
                        </div>
                      </div>

                      <div className="d-flex justify-content-between align-items-end">
                        <div className="text-center">
                          <div style={{ fontSize: "12px", color: "#707070" }}>{currentYear}</div>
                          <div style={{ fontSize: "18px", fontWeight: "bold", color: "#494949" }}>
                            {emissionsData[key]["2023"].value.toLocaleString()}
                          </div>
                        </div>

                        <div className="text-center">
                          <div style={{ fontSize: "12px", color: "#707070" }}>{previousYear}</div>
                          <div style={{ fontSize: "18px", fontWeight: "bold", color: "#494949" }}>
                            {emissionsData[key]["2022"].value.toLocaleString()}
                          </div>
                        </div>

                        <div className="text-center">
                          <div style={{ fontSize: "12px", color: "#707070" }}>Change</div>
                          <div className="d-flex align-items-center justify-content-center">
                            <img
                              src={
                                emissionsData[key].change <= 0
                                  ? "../assets/img/icon/GreenDown.svg"
                                  : "../assets/img/icon/RedUp.svg"
                              }
                              alt="change icon"
                              style={{ width: "20px", height: "18px", marginRight: "4px" }}
                            />
                            <span
                              style={{
                                fontSize: "18px",
                                fontWeight: "600",
                                color: emissionsData[key].change <= 0 ? "#28A745" : "#D9534F",
                              }}
                            >
                              {Math.abs(emissionsData[key].change)}%
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Charts Section */}
              <div className="row">
                <div className="col-12 col-lg-6">
                  <div
                    className="charts"
                    style={{
                      padding: "15px",
                      backgroundColor: "#fff",
                      borderRadius: "8px",
                      height: "380px",
                      marginBottom: "10px",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    }}
                  >
                    {hasEmissionsCommuteData ? (
                      <ResponsiveContainer width="100%" height={400}>
                        <HighchartsReact highcharts={Highcharts} options={emissionsChartConfig} />
                      </ResponsiveContainer>
                    ) : (
                      <NoDataComponent
                        title="Emissions Share by Commute Mode"
                        onConfigureClick={handleConfigureClick}
                      />
                    )}
                  </div>
                </div>
                <div className="col-12 col-lg-6">
                  <div
                    className="charts"
                    style={{
                      padding: "15px",
                      backgroundColor: "#fff",
                      borderRadius: "8px",
                      marginBottom: "10px",
                      height: "380px",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    }}
                  >
                    {hasCommuteModeData ? (
                      <ResponsiveContainer width="100%" height={400}>
                        <HighchartsReact highcharts={Highcharts} options={commuteModeChartConfig} />
                      </ResponsiveContainer>
                    ) : (
                      <NoDataComponent
                        title="Primary Commute Mode of Employees"
                        onConfigureClick={handleConfigureClick}
                      />
                    )}
                  </div>
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-12 col-lg-6">
                  <div
                    className="charts"
                    style={{
                      padding: "15px",
                      backgroundColor: "#fff",
                      borderRadius: "8px",
                      marginBottom: "20px",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    }}
                  >
                    {hasAverageTravelCommuteData ? (
                      <ResponsiveContainer width="100%" height={400}>
                        <HighchartsReact highcharts={Highcharts} options={averageTravelCommuteModeChartConfig} />
                      </ResponsiveContainer>
                    ) : (
                      <NoDataComponent
                        title="Average One-way Travel by Commute Mode"
                        onConfigureClick={handleConfigureClick}
                      />
                    )}
                  </div>
                </div>
                <div className="col-12 col-lg-6">
                  <div
                    className="charts"
                    style={{
                      padding: "15px",
                      backgroundColor: "#fff",
                      borderRadius: "8px",
                      marginBottom: "20px",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    }}
                  >
                    {hasAverageTravelSiteData ? (
                      <ResponsiveContainer width="100%" height={350}>
                        <HighchartsReact highcharts={Highcharts} options={averageTravelSiteLocationChartConfig} />
                      </ResponsiveContainer>
                    ) : (
                      <NoDataComponent
                        title="Average One-way Travel by Site Location"
                        onConfigureClick={handleConfigureClick}
                      />
                    )}
                  </div>
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-12 col-lg-6">
                  <div
                    className="charts"
                    style={{
                      padding: "15px",
                      backgroundColor: "#fff",
                      borderRadius: "8px",
                      marginBottom: "20px",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    }}
                  >
                    {hasAnnualEmissionSiteData ? (
                      <ResponsiveContainer width="100%" height={400}>
                        <HighchartsReact highcharts={Highcharts} options={annualEmissionSiteChartConfig} />
                      </ResponsiveContainer>
                    ) : (
                      <NoDataComponent
                        title="Annual Per-employee Emission by Site"
                        onConfigureClick={handleConfigureClick}
                      />
                    )}
                  </div>
                </div>
                <div className="col-12 col-lg-6">{/* Additional chart can be added here */}</div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
